import React, { useState } from 'react';
import { Card, List, Button, Form } from "tabler-react";
import Select from 'react-select';
import { useFetch } from '../../lib/useFetch';

import PostObject from '../../lib/postObject';
const NotificationUserModal = ({ recordId, closeMainModal }) => {
    const [form, changeFormInput] = useState({
        notificationId: null,
        ids: [],
    });
    const [userString] = useState('');
    const { data: users, loading: usersLoading } = useFetch(`users?email=${userString}`);
    const [saveLoading, toggleSaveLoading] = useState(false)

    const submitForm = () => {
        let tempUsers = [];
        form.ids.forEach((element) => {
            tempUsers.push(element.value._id);
        });
        const notification = {
            notificationId: recordId,
            ids: tempUsers,
        }

        toggleSaveLoading(true)
        PostObject('notifications/notifyUsers', notification).then(() => {
            toggleSaveLoading(false)
            closeMainModal()
        });
    }

    return (
        <Card>
            <Card.Header>
                <Card.Title>Send  Notification To Users</Card.Title>
                <Card.Options>
                    <Button
                        size="sm"
                        icon="x"
                        onClick={() => closeMainModal()}
                    />
                </Card.Options>
            </Card.Header>
            <Card.Body>
                <Form>
                    <Form.FieldSet>
                        <Form.Label>emails: </Form.Label>
                        <List.GroupItem>
                            <Select
                                value={form.owner}
                                options={users && users.map(user => {
                                    return ({ label: user.email, value: user });
                                })}
                                isSearchable
                                isMulti
                                placeholder="emails"
                                isLoading={usersLoading}
                                onChange={(e) => { changeFormInput({ ...form, ids: e }); }}
                            />
                        </List.GroupItem>
                    </Form.FieldSet>
                </Form>
            </Card.Body>
            <Card.Footer>
                <div style={{ textAlign: 'right' }}>
                    <Button
                        color="primary"
                        size="sm"
                        className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
                        type="submit"
                        onClick={submitForm}
                        disabled={saveLoading}
                    >
                        Save
                    </Button>
                    <Button
                        color="secondary"
                        size="sm"
                        className="ml-2"
                        onClick={() => closeMainModal()}
                        disabled={saveLoading}
                    >
                        cancel
                    </Button>
                </div>
            </Card.Footer>
        </Card>
    )
}

export default NotificationUserModal;